// Libraries
import { PropsWithChildren } from 'react';
// Components
import { RootLayout } from '@layout/index';
import { VesselNavbar } from '@organisms/index';

/**
 * `CiiSimulatorLayout` provides a layout specific for the CII (Carbon Intensity Indicator) Simulator.
 * It wraps the given children with the base `RootLayout` and includes the `VesselNavbar` component.
 *
 * @component
 * @param {ReactNode} children - React elements or components to be displayed within this layout.
 *
 * @returns {ReactElement} The composed layout with `VesselNavbar` and the provided children.
 */
export const CiiSimulatorLayout = ({ children }: PropsWithChildren) => {
  return (
    <RootLayout>
      <VesselNavbar position='sticky' zIndex='docked' top={{ base: 16, md: 12 }} />
      {children}
    </RootLayout>
  );
};
